import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class ModuleAccessGroupStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getIndex(accessGroupId, moduleId) {
        return this._state.findIndex((el) => el !== undefined && el.id === accessGroupId && el.moduleId === moduleId);
    }

    getByModule(moduleId) {
        return this.getState().filter((m) => m !== undefined && m.moduleId === moduleId);
    }

    reduce(state, action) {
        switch(action.type) {
            case ActionTypes.MODULE_ACCESS_GROUP_LIST_SUCCESS:
                return update(this.getState(), { $set: action.data });

            case ActionTypes.MODULE_ACCESS_GROUP_ADD_SUCCESS:
                return update(this.getState(), { $push: action.data });

            case ActionTypes.MODULE_ACCESS_GROUP_REMOVE_SUCCESS:
                if (action.data) {
                    const index = this.getIndex(action.payload.accessGroupId, action.payload.moduleId);
                    return update(this.getState(), { $splice: [[index, 1]] });
                }
                return state;

            default:
                return state;
        }
    }
}

export default new ModuleAccessGroupStore(CentricDispatcher);
